import { React, createElement, Component, cloneElement, Children } from 'react';

/**
 * Concatenate two or more React children objects
 *
 * @param  {...?Object} childrenArguments Array of children arguments (array of arrays/strings/objects) to concatenate
 * @return {Array}                        The concatenated value
 */
export function concatChildren(...childrenArguments) {
	return childrenArguments.reduce((memo, children, i) => {
		Children.forEach(children, (child, j) => {
			if (child && 'string' !== typeof child) {
				child = cloneElement(child, {
					key: [i, j].join(),
				});
			}

			memo.push(child);
		});

		return memo;
	}, []);
}


// WEBPACK FOOTER //
// ./dev/stylist_parent/components/utils.js